<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> Danh sách công tác (Test)
        </span>

        <a-button
          slot="extra"
          type="primary"
          @click="() => (visibleAdd = true)"
        >
          <a-icon type="plus" /> Thêm
        </a-button>
      </div>

      <a-table
        :columns="columnAllLists"
        :data-source="datas"
        size="small"
        :loading="loadingList"
        rowKey="id"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <div slot="footer">
          <a-button
            :loading="loadingList"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Tải thêm
          </a-button>
        </div>
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>
        <div slot="employee" slot-scope="text, record">
          <span v-if="record.employee"> {{ record.employee.fullname }} </span>
        </div>

        <span slot="startDate" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="endDate" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="updatedAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="action" style="float: right;" slot-scope="text, record">
          <a-button @click="collapseVisibleEdit(record.id)">
            <a-icon title="Chỉnh sửa" type="edit" /> Chỉnh sửa
          </a-button>
        </span>
      </a-table>

      <a-drawer
        v-if="visibleEdit"
        title="Chỉnh sửa"
        placement="right"
        :visible="visibleEdit"
        @close="() => (visibleEdit = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <EditItem
          :idItem="idItem"
          :close="() => (visibleEdit = false)"
          :refreshAfterUpdated="refreshAfterUpdated"
          :refreshAfterDeleted="refreshAfterDeleted"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleAdd"
        title="Thêm mới"
        placement="right"
        :visible="visibleAdd"
        @close="() => (visibleAdd = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <AddItem
          :close="() => (visibleAdd = false)"
          :refreshAfterCreated="refreshAfterCreated"
        />
      </a-drawer>
    </a-card>
  </div>
</template>
<script>
import { columnAllLists } from "./constant/column";
import AddItem from "./components/AddItem";
import EditItem from "./components/EditItem";
import query from "./constant/query";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";
import debounce from "lodash/debounce";

const limit = 10;
const startPage = 1;
const defaultFilter = { query: "", status: "ACTIVE" };

export default {
  components: {
    AddItem,
    EditItem,
  },
  data() {
    this.onFilter = debounce(this.onFilter, 500);
    return {
      limit,
      visibleEdit: false,
      visibleDetail: false,
      visibleAdd: false,
      columnAllLists,
      loadingList: true,
      datas: [],
      idItem: "",
      filter: defaultFilter,
      currentPage: startPage,
      totalPage: startPage,
      isPagination: true,
    };
  },
  methods: {
    onGetListData(flag) {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getListOnBusinessForHr,
          fetchPolicy: "no-cache",
          variables: {
            limit,
            query: this.filter.query,
            page: this.totalPage,
            status: this.filter.status,
          },
        })
        .then(({ data }) => {
          this.loadingList = false;
          if (data?.getListOnBusinessForHr?.length >= 0) {
            if (flag === "FILTER") {
              this.datas = [...data.getListOnBusinessForHr];
            } else if (flag === "PAGINATION") {
              this.datas = this.datas.concat([...data.getListOnBusinessForHr]);
            } else {
              this.datas = [...data.getListOnBusinessForHr];
            }
            // check is pagniation
            if (data.getListOnBusinessForHr.length < limit) {
              this.isPagination = false;
            } else {
              this.isPagination = true;
            }
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Lấy danh sách  không thành công!",
          });
          console.log("Lấy danh sách  không thành công", err);
        });
    },
    collapseVisibleDetail(id) {
      if (id) {
        this.idItem = id;
        this.visibleDetail = true;
      } else {
        this.idItem = "";
        this.visibleDetail = false;
      }
    },
    collapseVisibleEdit(id) {
      if (id) {
        this.idItem = id;
        this.visibleEdit = true;
      } else {
        this.idItem = "";
        this.visibleEdit = false;
      }
    },
    onFilter() {
      this.currentPage = startPage;
      this.totalPage = startPage;
      this.onGetListData("FILTER");
    },
    refreshAfterUpdated(item) {
      this.datas = updateForUpdated(this.datas, item);
    },
    refreshAfterDeleted(item) {
      this.datas = updateForDeleted(this.datas, item);
    },
    refreshAfterCreated(item) {
      this.datas = updateForCreated({
        list: this.datas,
        item,
        limit,
        currentPage: this.currentPage,
      });
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.onGetListData("PAGINATION");
      }
    },
    onChangeStatusFilter(status) {
      this.$set(this.filter, "status", status || undefined);
      this.onFilter();
    },
  },
  created() {
    this.onGetListData();
  },
};
</script>
<style lang="css" scoped></style>
